import initJSLinks from "@resources/js/js-links";

initJSLinks()
